const l = {
  name: "PlatformBusinessStructure",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 39.7 40" style="enable-background:new 0 0 39.7 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M10.8,0l10.8,7l-4.8,3.1l7.8,5.6l4.2-2.7l10.8,7l-10.8,7l-4.2-2.7l-7.8,5.6l4.8,3.1l-10.8,7L0,33l10.8-7
			l4.2,2.7l7.8-5.6L18,20l4.8-3.1l-7.8-5.6L10.8,14L0,7L10.8,0z M3.7,7l7.2,4.6L18,7l-7.2-4.6L3.7,7z M3.7,33l7.2,4.6L18,33
			l-7.2-4.6L3.7,33z M28.8,24.6L36,20l-7.2-4.6L21.7,20L28.8,24.6z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as PlatformBusinessStructure
};
